import type { ComposeQuotedBlock } from './types';

/** Update or append a `Label: value` line in quoted header metadata. */
export function updateQuotedHeaderLine(
  headerLines: string[],
  label: string,
  newValue: string,
): string[] {
  if (headerLines.length === 0) return [`${label}: ${newValue}`];
  const heading = headerLines[0];
  const rest = headerLines.slice(1);
  const labelLower = label.trim().toLowerCase();
  let found = false;
  const updated = rest.map((line) => {
    const colon = line.indexOf(':');
    if (colon <= 0) return line;
    const lineLabel = line.slice(0, colon).trim().toLowerCase();
    if (lineLabel === labelLower) {
      found = true;
      return `${line.slice(0, colon).trim()}: ${newValue}`;
    }
    return line;
  });
  if (!found) updated.push(`${label}: ${newValue}`);
  return [heading, ...updated];
}

export function patchQuotedBlock(
  quoted: ComposeQuotedBlock,
  patch: Partial<Pick<ComposeQuotedBlock, 'headerLines' | 'bodyHtml' | 'bodyText'>>,
): ComposeQuotedBlock {
  return { ...quoted, ...patch };
}
